import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  }
}));

export default function DialogOutdatedCrits ({
  open,
  handleClose
}: {
  open: boolean
  handleClose: () => void
}) {
  const classes = useStyles();

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  return (
    <Dialog
      onClick={onClick}
      onClose={handleClose}
      open={open}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant='h3'>
          <Translate content='review_outdated_criteria_dialog_title' />
        </Typography>
        <IconButton
          onClick={handleClose}
          className={classes.closeButton}
        >
          <Icon type='cross' size='sm' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Translate content='review_outdated_criteria_dialog_content' />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
